<template>
  <div>
    <div class="signage-wrapper">
      <div>
        <div class="row border-bottom border-dark mb-4">
          <div class="col-4 align-self-center">
            <img
              src="@/assets/img/logos/logo-white.png"
              height="auto"
              width="100"
              class="img-fluid"
              alt
            />
          </div>
          <div class="col-4">
            <div class="signage-title">NOWSHOWING</div>
          </div>
          <div class="col-4 justify-content-end d-flex align-items-center">
            <h5 class="mb-0">{{currentTime}}</h5>
            <h5 class="mb-0 ml-4">{{currentDate}}</h5>
          </div>
        </div>

        <div class="screen-fit">
          <div class="col-md-11 mx-auto gradient_BoxShadow">
            <div class="row">
              <div v-for="(show,showKey) in finalMovies" :key="showKey" class="col-md-12">
                <!-- <div class="col-md-8"> -->
                <div class="row">
                  <div class="col-md-4">
                    <img
                      v-if=" show.md_thumbnail_url && show.md_thumbnail_url.length == 0"
                      :src="'/static/placeholder-image.png'"
                      class="rounded img-fluid d-block mx-auto"
                    />
                    <img
                      v-else
                      :src="_GetImagePath(show.md_thumbnail_url)"
                      class="rounded img-fluid d-block mx-auto"
                    />
                  </div>
                  <div class="col-md-8">
                    <div class="col-md-12">
                      <h1 class="font-weight-bold">{{ show.movie_title }}</h1>
                      <hr class="bg-white" />
                    </div>

                    <div class="col-md-12">
                      <ul class="signage-info">
                        <li>
                          <div class="signage-format">
                            <h3 class="mb-0">{{show.mf_name}}</h3>
                          </div>
                        </li>
                        <li>
                          <div
                            class="signage-lang d-flex justify-content-center align-items-center"
                          >
                            <h3 class="mb-0">{{show.lang_name}}</h3>
                          </div>
                        </li>
                        <li>
                          <div class="d-flex justify-content-center align-items-center">
                            <h3 class="mb-0">({{show.rating}})</h3>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="col-md-12">
                      <h4 class="pt-3">{{show.screen_name}}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import signageServices from "@/services/signageService";
import Slick from "vue-slick";

export default {
  components: {
    Slick
  },
  data() {
    return {
      silderOne: {
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: false,
        slidesToShow: 4
      },
      finalMovies: []
    };
  },
  beforeMount() {
    const cine_ID = this.$route.params.id1;
    const screen_ID = this.$route.params.id2;
    this.getMovies(cine_ID, screen_ID);
  },
  computed: {
    currentTime() {
      return this.$store.getters.CURRENT_TIME;
    },
    currentDate() {
      return this.$store.getters.CURRENT_DATE;
    }
  },
  methods: {
    getMovies: function(cine_ID, screen_ID) {
      let payload = { cinema_id: cine_ID, screen_id: screen_ID };
      signageServices
        .getNowShowing(payload)
        .then(response => {
          const { data } = response;
          console.log("response :", response);

          let movies = data.Records;
          movies.map(x => {
            x["showTimes"] = [];
          });
          data.Records.map(x => {
            movies.map(y => {
              if (x.movie_id == y.movie_id) {
                y.showTimes.push(x.ss_start_show_time);
              }
            });
          });

          function removeDuplicates(originalArray, prop) {
            var newArray = [];
            var lookupObject = {};

            for (var i in originalArray) {
              lookupObject[originalArray[i][prop]] = originalArray[i];
            }

            for (i in lookupObject) {
              newArray.push(lookupObject[i]);
            }
            return newArray;
          }
          this.finalMovies = removeDuplicates(movies, "movie_id");
          console.log("finalMovies :", this.finalMovies);
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(0, true);
          });
          // self.show_details=data.Records;
          //  console.log("Acutall",self.show_details[0].ss_id);

          //   console.log("Actual data", self.show_details);

          //  var a;
          //  for (i in self.show_details.movie_title) {
          //    a=  self.show_details.movie_title[i];
          //  }

          //     var g = _groupBy(a,function(value){
          //       return value.movie_title;
          //     });
          //      self2.singleMovie=g;

          //   var cars={[
          //     {"name":"ABCD","year":"2010"},
          //     {"name":"ABCD","year":"2010"},
          //     {"name":"Kabir","year":"2005"}
          // ]};
          // var g = _groupBy(cars, function(value){
          //    return car.name;
          // });
          // document.write(g);
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>

<style>
.movie_title {
  font-size: 20px;
}

.screen-fit {
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gradient_BoxShadow {
  box-shadow: 1px 1px 10px 3px #8080807a;
  border-radius: 15px;
  padding: 20px;
}

.img_size {
  width: 90%;
}

.signage-wrapper {
  width: 100%;
  padding: 20px;
  color: #fff;
  height: 100vh;

  overflow: hidden;
  background: #000000;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to top, #434343, #000000, #000000);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to top, #434343, #000000, #000000);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.signage-title {
  height: 65px;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.signage-wrapper .single-movie {
  width: 90%;
  padding: 15px 20px;
  margin: 0 auto;
  text-align: left;
  border-radius: 5px;
  background: #222222;
  /* border: 1px solid grey; */
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 10px 3px #8080807a;
}

.single-movie h5 {
  line-height: 1;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 20px;
  padding: 18px 0 15px 0;
  text-transform: uppercase;
  border-bottom: 1px solid GREY;
}

.single-movie img {
  width: 100%;
}

.signage-info,
.signage-timing-list {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0px;
  display: inline-flex;
  flex-wrap: wrap;
}

.signage-info li,
.signage-timing-list li {
  border-radius: 5px;
  flex-wrap: wrap;
  display: flex;
  font-size: 20px;
  font-weight: 400;
}

.signage-timing-list li {
  padding: 5px 15px;
  margin-bottom: 10px;
  border: 1px solid grey;
}

.signage-timing-list li:not(:last-child) {
  margin-right: 10px;
}

.signage-info li:not(:last-child):after {
  width: 1px;
  content: "";
  height: 47px;
  display: block;
  margin: 0 10px;
  background-color: #d3d3d3;
}

.signage-format {
  padding: 6px 16px 6px 16px;
  display: table;
  line-height: 1;
  border-radius: 5px;
  border: 1px solid grey;
}

.single-movie h6 {
  font-size: 16px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/Signage/signage_NowShow.vue